import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'

/**
 * Basic health check - fast endpoint to verify API connectivity
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => api.health.get(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every minute
  })
}

/**
 * Detailed health check - includes database, Redis, Azure status
 */
export function useHealthDetailed() {
  return useQuery({
    queryKey: ['health', 'detailed'],
    queryFn: () => api.health.detailed(),
    staleTime: 30 * 1000,
  })
}

/**
 * Database stats - patient, invoice, branch counts
 */
export function useDbStats() {
  return useQuery({
    queryKey: ['health', 'db-stats'],
    queryFn: () => api.health.dbStats(),
    staleTime: 5 * 60 * 1000, // 5 minutes - stats don't change often
  })
}
